module.exports = __webpack_public_path__ + "static/softcube-342e63ee8d0194c020aa3479c155ef10.png";